import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SelectDropdown from './SelectDropdown';
import { updateCurrentCampaign, getCampaigns} from '../actions/campaigns/campaignCreators';

class CampaignSelect extends React.Component {

  componentWillMount() {
    const { organisationId, getCampaigns } = this.props;
    const excludeArchived = true;
    getCampaigns(organisationId, excludeArchived);
  }

  handleChange = campaignId => {
    const { organisationId, updateCurrentCampaign, context } = this.props;
    updateCurrentCampaign(campaignId, organisationId).then(
      success => {
      // redirect to correct url
      window.location.href = `/${context}/${organisationId}/campaigns/${campaignId}/map`;
    },
      failure => console.log('failure: ', failure)
    );
  }

  render() {
    const { campaigns, campaignId } = this.props;
    return (
      <div className="campaign-select">
        <SelectDropdown
          className="testing"
          onChange={this.handleChange}
          value={campaignId}
          options={campaigns}
          aria-label="Campaign Select Box"
        />
      </div>
    )
  }
};


function mapStateToProps(state) {
  return {
    campaigns: state.campaigns
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateCurrentCampaign,
    getCampaigns
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignSelect);



// WEBPACK FOOTER //
// ./src/components/CampaignSelect.js